// React & Hooks
import React, { useEffect, useState } from 'react';

// Routing Hooks
import { useSearchParams } from 'react-router-dom';

// Date/Time Utility
import moment from 'moment';

// Ant Design Components
import { Drawer } from 'antd';

// Local Components
import AttendanceTable from './AttendanceTable';
import FiltersDrawer from './FiltersDrawer';

// Redux Actions
import { FetchAttendanceHistoryList } from 'app/redux/actions/InitiativeUsher';

const AttendanceHistoryDashboard = () => {
  const [initiative, setInitiative] = useState(null);
  const [initiativeLabel, setInitiativeLabel] = useState(null);

  const [attendanceData, setAttendanceData] = useState(null);
  const [attendanceDataLoading, setAttendanceDataLoading] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);

  // Default to first & last day of current month
  const [routerSearchParams] = useSearchParams({
    start_date: moment().startOf('month').format('YYYY-MM-DD'),
    end_date: moment().endOf('month').format('YYYY-MM-DD'),
    search: '',
  });

  const [searchParams, setSearchParams] = useState({
    start_date:
      routerSearchParams.get('start_date') ||
      moment().startOf('month').format('YYYY-MM-DD'),
    end_date:
      routerSearchParams.get('end_date') ||
      moment().endOf('month').format('YYYY-MM-DD'),
    search: routerSearchParams.get('search', ''),
  });

  const showDrawer = () => {
    setOpenDrawer(true);
  };

  const closeDrawer = () => {
    setOpenDrawer(false);
  };

  async function fetchData() {
    setAttendanceDataLoading(true);
    const response = await FetchAttendanceHistoryList(
      initiative,
      Object.fromEntries(routerSearchParams),
    );
    setAttendanceData(response);
    setAttendanceDataLoading(false);
  }

  useEffect(() => {
    if (initiative) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initiative, searchParams]);

  return (
    <>
      <Drawer
        title="Filter Attendance History List"
        onClose={closeDrawer}
        open={openDrawer}
        style={{ paddingTop: '75px' }} // Adjust top padding to avoid overlaying the fixed navbar
      >
        <FiltersDrawer
          {...{
            setInitiative,
            setInitiativeLabel,
            searchParams,
            setSearchParams,
          }}
        />
      </Drawer>

      <AttendanceTable
        {...{
          fetchData,
          attendanceData,
          attendanceDataLoading,
          initiative,
          initiativeLabel,
          setInitiative,
          searchParams,
          setSearchParams,
          showDrawer,
        }}
      />
    </>
  );
};

export default AttendanceHistoryDashboard;
